<template>
  <router-link class="child-pages-navigation-link"
               active-class="child-pages-navigation-link_active"
               :to="location">
    <component class="child-pages-navigation-link__icon"
               width="28"
               height="28"
               :is="iconName" />
    <div v-if="this.$mq != 'mobile' && this.$mq != 'small'">
      {{ text }}
    </div>
  </router-link>
</template>

<script>
  export default {
    props: {
      text: {
        required: true,
        type: String
      },

      location: {
        required: true,
        type: [String, Object]
      },

      iconName: {
        required: true,
        type: String
      }
    }
  }
</script>


<style lang="scss" scoped>
  .child-pages-navigation-link {
    position: relative;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    padding: 0 17px;
    font-size: 21px;
    color: #999;
    text-decoration: none;
    transition: all .1s ease-out;

    &:hover,
    &_active {
      color: map-get($colors, primary);
    }

    &__icon {
      flex-shrink: 0;
      margin-right: 12px;
    }

    &:not(:last-child)::after {
      position: absolute;
      top: 50%;
      right: 0;
      content: '';
      display: block;
      height: 33px;
      width: 2px;
      background-color: #f2f2f2;
      transform: translateY(-50%);
    }
  }
</style>
